import $ from 'jquery';
import "magnific-popup";

export default class VideoPlayer {
    constructor() {
        this.selectors = {
            video: '[data-role="video-player"]',
            thumbnail: '[data-role="thumbnail"]',
            playButton: '[data-role="play-button"]'
        };

        this.pageVideos = new Array();

        this.init();
    }

    init() {
        let $videosContainers = $(this.selectors.video);
        if ($videosContainers.length === 0)
            return;

        $videosContainers.each((i, vp) => {
            let $vp = $(vp);
            let $thumbnail = $vp.find(this.selectors.thumbnail);
            let $playButton = $vp.find(this.selectors.playButton);

            if ($thumbnail.length) {
                let imgSrc = $thumbnail.attr('data-src');
                if (!imgSrc) {
                    let videoUrl = $playButton.attr('href');

                    if (videoUrl.indexOf('vimeo') > 0) {
                        $.get({
                            url: 'https://vimeo.com/api/oembed.json?url=' + videoUrl
                        }).done(function (data) {
                            $thumbnail.css('background-image', `url(${data.thumbnail_url})`);
                        }).fail(function () {
                            console.log('Unable to retrive video thambnail (vimeo)');
                        });
                    } else if (videoUrl.indexOf('youtube.com') > 0 || videoUrl.indexOf('youtu.be') > 0) {
                        const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|shorts|user)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
                        const match = videoUrl.match(regExp);

                        if (match && match[1])
                            $thumbnail.css('background-image', `url(https://img.youtube.com/vi/${match[1]}/0.jpg)`);
                    }
                }
                else
                    $thumbnail.css('background-image', `url(${imgSrc})`);
            }

            this.pageVideos.push({
                thumbnail: $thumbnail,
                playButton: $playButton,
                animationEffect: $vp.attr('data-effect')
            });
        });

        this.bindEvents();
    }

    bindEvents() {
        this.pageVideos.forEach(el => {
            el.playButton.on('click', (e) => {
                e.preventDefault();

                $.magnificPopup.open({
                    items: {
                        src: ''
                    },
                    type: 'iframe',
                    iframe: {
                        markup: `<div class="mfp-iframe-scaler">'
                                    <div class="mfp-close"></div>
                                    <iframe title="video" class="mfp-iframe" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                                </div>`
                    },
                    mainClass: el.animationEffect,
                    removalDelay: 500,
                    callbacks: {
                        beforeOpen: function () {
                            this.contentContainer.addClass('mfp-with-anim');
                        },
                        elementParse: function (item) {
                            var videoSrc = el.playButton.attr('href').split("?")[0];

                            if (videoSrc.indexOf('vimeo') > 0) {
                                const regex = /vimeo\.com\/(?:.*\/)?(\d+)/;
                                const match = videoSrc.match(regex);
                                if (match && match[1])
                                    item.src = `https://vimeo.com/${match[1]}`;
                            }
                            else if (videoSrc.indexOf('youtube.com') > 0 || videoSrc.indexOf('youtu.be') > 0) {
                                const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|shorts|user)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
                                const match = videoSrc.match(regExp);
                                if (match && match[1])
                                    item.src = `https://www.youtube.com/watch?v=${match[1]}`
                            }
                            else if (videoSrc.indexOf('.mp4') > 0) {
                                item.src = videoSrc;
                            }
                        },
                        close: function () {
                            this.contentContainer.find('iframe').prop('src', null);
                        }
                    },
                    midClick: true
                });
            });
        });
    }
}